export default __webpack_public_path__ + "static/media/Factory-of-the-Future-Leadership.e606dd2c.pdf";